<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">
        {{ item?.id ? $t('serviceCategoryEditModalTitle') : $t('serviceCategoryCreateModalTitle') }}
      </div>
    </template>
    <Spinner v-if="dataIsSending" :overlayStyle="'height: 80px'"/>

    <div v-else class="p-formgrid p-grid p-pt-3">
      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12">
        <div class="p-float-label">
          <InputText id="service-category-name" :class="{'p-invalid' : submitted && !serviceCategoryData.name}" v-model.trim="serviceCategoryData.name" autocomplete="off"/>
          <label for="service-category-name">{{ $t('Name') }}<span class="warning-color">*</span></label>
        </div>
        <small class="p-invalid" v-if="submitted && !serviceCategoryData.name">{{ $t('Required field') }}</small>
      </div>
    </div>
    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')"
              :disabled="dataIsSending || disableSaveButton"
              :loading="dataIsSending"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveItem"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import httpMixins from "@/mixins/httpMixins";
import settings from "@/settings";

export default {
  mixins: [ httpMixins ],
  emits: ['close', 'update-items'],
  name: 'ServiceCategoryModal',
  props: {
    item: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataIsSending: false,
      disableSaveButton: false,
      serviceCategoryData: {},
      submitted: false
    }
  },
  watch: {
    item(value) {
      // if (!value) return
      // this.serviceCategoryData = { ...value }
      this.serviceCategoryData = value ? { ...value } : {}
    },
    visible() {
      if (!this.visible) {
        this.disableSaveButton = false
        this.dataIsSending = false
        this.submitted = false
      }
    },
  },
  methods: {
    async saveItem() {
      this.submitted = true
      if (!this.serviceCategoryData.name) {
        return false
      }
      this.disableSaveButton = true
      this.dataIsSending = true

      const serviceCategory = {
        name: this.serviceCategoryData.name ?? null,
        sorting: this.serviceCategoryData.sorting ?? null,
      }

      if (this.serviceCategoryData.id) {
        serviceCategory.id = this.serviceCategoryData.id
        try {
          const { status, data } = await httpClient.post(`service/update-category`, serviceCategory)
          if (status === 200 && data?.success) {
            this.$emit('update-items', this.serviceCategoryData.id)
            this.$toast.add({severity: 'success', detail: this.$t('Data updated'), life: settings.toastLife});
            this.close()
          } else if (data?.error) {
            this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      } else {
        try {
          const { status, data } = await httpClient.post(`service/create-category`, serviceCategory)
          if (status === 201 && data?.success) {
            this.serviceCategoryData.id = data.id
            serviceCategory.id = data.id
            this.$emit('update-items', this.serviceCategoryData.id)
            this.$toast.add({severity:'success', detail: this.$t('Data saved'), life: settings.toastLife});
            this.close()
          } else if (data?.error) {
            this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      }
    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout) {
        return {width: '95%', maxWidth: '420px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {width: '420px'}
      } else {
        return {width: '420px'}
      }
    },
  },

}
</script>